import { PageHero } from "../components/PageHero";
import { ContactSection } from "../components/ContactSection";
import { usePageMeta } from "../hooks/usePageMeta";

export default function Contatti() {
  usePageMeta(
    "Contatti e preventivi | Nuova Giga Print Roma",
    "Richiedi un preventivo a Nuova Giga Print. Sede: Via Giovanni Neper 14, 00166 Roma. Tel +39 06 69 42 20 20."
  );
  return (
    <>
      <PageHero eyebrow="Contatti" title="Parliamo del tuo progetto." img="/img/company.webp" alt="Reparto stampa Nuova Giga Print" />
      <ContactSection withHead={false} />
    </>
  );
}
